import { ColDef } from './types';

/** 이 화면은 전/후 정확히 2개 UT Matrix만 비교한다 (기계 화면도 동일하게 MAX_COMPARE=2) */
export const MAX_COMPARE_ELEC = 2;

/** UT Matrix 정합화 Report 저장 시 이 화면(전기)이 사용하는 항목구분코드(ATC_DIVS_CD) */
export const ATC_DIVS_CD_ELEC = 'ELEC';

/** 변경내역 상세표 칼럼 정의 — HTML 툴(UT_Matrix_비교분석_Rev15.html)의 COLS를 그대로 포팅 */
export const COLS: ColDef[] = [
  { id: 'difTpCtn', label: '유형', width: 130, align: 'center' },
  { id: 'prdnProcNm', label: '공정', width: 95, align: 'left' },
  { id: 'eqclNm', label: '설비군', width: 130, align: 'left' },
  { id: 'dtalProcNm', label: '세부공정', width: 100, align: 'left' },
  { id: 'bizAreaNm', label: 'Area', width: 65, align: 'center', group: 'loc' },
  { id: 'bldgFloCd', label: 'Floor', width: 52, align: 'center', group: 'loc' },
  { id: 'istlLocNm', label: 'Room', width: 68, align: 'center', group: 'loc' },
  { id: 'lnBf', label: 'Line 전', width: 58, align: 'center' },
  { id: 'lnAf', label: 'Line 후', width: 58, align: 'center' },
  { id: 'eqpMainNm', label: 'Main', width: 75, align: 'center' },
  { id: 'eqpMchNm', label: 'Machine', width: 150, align: 'left' },
  { id: 'qtyBf', label: "Q'ty 전", width: 55, align: 'right', group: 'elec' },
  { id: 'qtyAf', label: "Q'ty 후", width: 55, align: 'right', group: 'elec' },
  { id: 'voltage', label: 'Voltage', width: 88, align: 'center', group: 'elec' },
  { id: 'brkBf', label: 'Brk 전', width: 72, align: 'right', group: 'elec' },
  { id: 'brkAf', label: 'Brk 후', width: 72, align: 'right', group: 'elec' },
  { id: 'capBf', label: 'Cap 전', width: 70, align: 'right', group: 'elec' },
  { id: 'capAf', label: 'Cap 후', width: 70, align: 'right', group: 'elec' },
  { id: 'csumBf', label: 'CSum 전', width: 72, align: 'right', group: 'elec' },
  { id: 'csumAf', label: 'CSum 후', width: 72, align: 'right', group: 'elec' },
  { id: 'dfBf', label: 'DF 전', width: 55, align: 'right', group: 'elec' },
  { id: 'dfAf', label: 'DF 후', width: 55, align: 'right', group: 'elec' },
  { id: 'dmdCapaBf', label: '수용율 용량(kW) 전', width: 100, align: 'right', group: 'elec' },
  { id: 'dmdCapaAf', label: '수용율 용량(kW) 후', width: 100, align: 'right', group: 'elec' },
  { id: 'connType', label: 'Conn. Type', width: 100, align: 'center', group: 'elec' },
  { id: 'brkAnlsCtnBf', label: '차단기 분석내용(전)', width: 110, align: 'center', group: 'elec' },
  { id: 'brkAnlsCtnAf', label: '차단기 분석내용(후)', width: 110, align: 'center', group: 'elec' },
];

/**
 * 변경 내역 상세표(ElecDetailTable)에서 감출 칼럼.
 *
 * COLS의 정의는 그대로 두고 화면 노출만 막는다 — 값 계산·저장 경로는 건드리지 않으므로
 * 여기서 id만 빼면 즉시 다시 보인다. 열 표시/숨기기 토글 바에도 나오지 않는다.
 */
export const HIDDEN_DETAIL_COL_IDS: ReadonlySet<string> = new Set(['brkAnlsCtnBf']);

/** 그룹 합계 비교 시 Capacity/수용율 오차 허용치 (kW) — 반올림 등으로 인한 사소한 차이는 무시 */
export const CAPA_EPS = 0.15;
